// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app.scss
// module id = ./src/app.scss
// module chunks = 0